import { createFileRoute, Link } from '@tanstack/react-router'
import { NAVIGATION_ICONS } from './-components/shared/navigation-config'
import { useLingui } from '@lingui/react/macro'
import { Logo } from './-components/shared/logo'
import { useAppStore } from '@/lib/app-store'
import { Animate } from './-components/animate'
import { PageLayout, ScrollableContent, ScrollableArea } from './-components/shared/layout'
import { BreadcrumbTrail } from './-components/title-section'
import { ReportComponent } from './-components/report/report'
import { ReportPaneSkeleton } from './-components/app-layout-skeleton'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'

export const Route = createFileRoute('/_app/market')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params, false, true)
  },
  component: RouteComponent,
  pendingComponent: ReportPanePending,
})

function ReportPanePending() {
  return (
    <Animate className="h-full">
      <ReportPaneSkeleton />
    </Animate>
  )
}

function RouteComponent() {
  const { t } = useLingui()
  const extension = useAppStore((state) => state.store.extension)
  const callback = useAppStore((state) => state.store.callback)

  const breadcrumbs = [
    {
      label: t`Market`,
      link: (
        <Link
          to="/market"
          search={(prev) => ({ ...prev, first: { type: 'market' }, second: undefined, selected: undefined })}
        >
          {t`Market`}
        </Link>
      ),
    },
  ]

  return (
    <>
      <div id="report" className="@container flex h-full flex-col">
        {extension && <Logo openInNewTab />}
        <PageLayout
          icon={NAVIGATION_ICONS.market}
          title={t`Market`}
          breadcrumbsSlot={<BreadcrumbTrail items={breadcrumbs} />}
        >
          <ScrollableContent>
            <ScrollableArea>
              <ReportComponent callback={callback} />
            </ScrollableArea>
          </ScrollableContent>
        </PageLayout>
      </div>
    </>
  )
}
